import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SettingsState {
  // UI Scale
  uiScale: number;
  setUIScale: (scale: number) => void;
  
  // Other settings can be added here
  theme: 'light' | 'dark';
  setTheme: (theme: 'light' | 'dark') => void;
}

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      // UI Scale (0.8 = 80%, 1.0 = 100%)
      uiScale: 0.8, // Default to 80% scale
      setUIScale: (scale) => set({ uiScale: scale }),
      
      // Theme
      theme: 'light',
      setTheme: (theme) => set({ theme }),
    }),
    {
      name: 'sov-vision-settings',
    }
  )
);